<div class="card shadow-sm no-overscroll">
    <p-table #dt1 [value]="allOrders" scrollable="true" scrollHeight="70vh" dataKey="order_id" [rows]="50"
        [sortField]="'order_id'" [sortOrder]="-1" [rowsPerPageOptions]="[10, 25, 50]" styleClass="p-datatable-lg"
        [expandedRowKeys]="expandedRows" [globalFilterFields]="[
        'trailer_id', 
        'supplier_id',
        'receiver_id',
        'pickup_driver_id',
        'delivery_driver_id',
        'load_type',
        'load_status',
        'pickup_number',
        'notes',
        'pickup_driver_name',
        'delivery_driver_name',
        'trailer_number',
        'shipper_name',
        'receiver_name'
        ]" [showCurrentPageReport]="true" [paginator]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} orders" paginatorPosition="bottom">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center p-3">
                <!-- Left side spacer -->
                <div class="flex-none w-1"></div>
                <!-- Middle - Search and Clear -->
                <div class="flex-grow-1 flex justify-content-center align-items-center gap-3">
                    <span class="p-input-icon-left w-full md:w-25rem">
                        <i class="pi pi-times cursor-pointer" (click)="clear(dt1)"></i>
                        <input class="custom-search" pInputText #searchInput type="text" placeholder="Search orders..."
                            autocomplete="off" (input)="dt1.filterGlobal($any($event.target).value, 'contains')"
                            class="w-full p-3"
                            [style]="{'border-radius': '12px', 'border': '1px solid var(--surface-300)', 'width':'300px', 'height': '4px'}" />
                    </span>
                </div>

                <!-- Right side - Add New Order button -->
                <div class="flex gap-2">
                    <button *ngIf="hasAccess" pButton icon="pi pi-plus" label="Add New Order" [raised]="true"
                        severity="info" (click)="OpenNewOrderDialog()" [outlined]="true"></button>
                    <button *ngIf="hasAccess" pButton icon="pi pi-plus" label="Import Tenders" [raised]="true"
                        severity="info" (click)="ImportTenders()" [outlined]="true"></button>
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr class="border-round-left-2xl">
                <!-- Order ID -->
                <th class="font-medium text-md">
                    <div class="flex align-items-center justify-content-between">
                        <span>Pickup #</span>

                    </div>
                </th>

                <!-- Trailer ID -->
                <th class="font-medium text-md">
                    <div class="flex align-items-center justify-content-between">
                        <span>Trailer</span>

                    </div>
                </th>

                <!-- Supplier/Shipper column -->
                <th class="font-medium text-md" pSortableColumn="shipper_name">
                    <div class="flex align-items-center justify-content-between">
                        <span>Shipper</span>
                        <p-sortIcon field="shipper_name" />
                    </div>
                </th>

                <!-- Receiver column -->
                <th class="font-medium text-md" pSortableColumn="receiver_name">
                    <div class="flex align-items-center justify-content-between">
                        <span>Receiver</span>
                        <p-sortIcon field="receiver_name" />
                    </div>
                </th>

                <!-- Delivery Date -->
                <th class="font-medium text-md" pSortableColumn="delivery_date">
                    <div class="flex align-items-center justify-content-between">
                        <span>Delivery Date</span>
                        <p-sortIcon field="delivery_date" />
                    </div>
                </th>

                <!-- Type -->
                <th class="font-medium text-md">
                    <div class="flex align-items-center justify-content-between">
                        <span>Type</span>
                        <p-columnFilter field="load_type" matchMode="equals" display="menu">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-dropdown [ngModel]="value" [options]="loadType" (onChange)="filter($event.value)"
                                    placeholder="Select">
                                </p-dropdown>
                            </ng-template>
                        </p-columnFilter>
                    </div>
                </th>



                <!-- Status -->
                <th class="font-medium text-md">
                    <div class="flex align-items-center justify-content-between">
                        <span>Status</span>
                        <p-columnFilter field="load_status" matchMode="equals" display="menu">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-dropdown [ngModel]="value" [options]="status" (onChange)="filter($event.value)"
                                    placeholder="Select">
                                </p-dropdown>
                            </ng-template>
                        </p-columnFilter>
                    </div>
                </th>

                <!-- Notes -->
                <th class="font-medium text-md">
                    <div class="flex align-items-center justify-content-between">
                        <span>Notes</span>
                    </div>
                </th>
            </tr>
        </ng-template>

        <!-- Table Body -->
        <ng-template pTemplate="body" let-order>
            <tr [id]="'order-' + order.order_id" class="cursor-pointer hover:surface-100"
                (click)="toggleRow(order.order_id)">
                <td class="font-medium">{{ order.pickup_number }}</td>
                <td>
                    <span class="font-medium">{{ order.trailer_number || order.external_trailer_number || ''}}</span>
                </td>
                <td class="font-medium">
                    <span
                        class="cursor-pointer transition-colors transition-duration-200 hover:text-blue-600 hover:underline"
                        [pTooltip]="getSupplierAddressTooltip(order)" tooltipPosition="top"
                        [tooltipOptions]="{ tooltipStyleClass: 'custom-address-tooltip' }"
                        (click)="onCustomerClick(order.supplier_id, order.supplier_address_id)">
                        {{ getCustomerName(order.supplier_id) }}
                    </span>
                </td>
                <td class="font-medium">
                    <span
                        class="cursor-pointer transition-colors transition-duration-200 hover:text-blue-600 hover:underline"
                        [pTooltip]="getReceiverAddressTooltip(order)" tooltipPosition="top"
                        [tooltipOptions]="{ tooltipStyleClass: 'custom-address-tooltip' }"
                        (click)="onCustomerClick(order.receiver_id, order.receiver_address_id)">
                        {{ getCustomerName(order.receiver_id) }}
                    </span>
                </td>
                <td>
                    <span *ngIf="order.delivery_date" class="p-2 border-round-sm text-sm font-medium">
                        {{ toCentralTime(order.delivery_date) }}
                    </span>
                </td>

                <td>
                    <span class="p-2 border-round-sm text-sm font-medium">
                        {{ order.load_type }}
                    </span>
                </td>
                <td>
                    <p-tag [value]="order.load_status" [severity]="getSeverity(order.load_status)" />
                </td>
                <td>
                    <span class="text-500">{{ order.notes }}</span>
                </td>
            </tr>
        </ng-template>

        <!-- Empty State -->
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="8">
                    <div class="flex flex-column align-items-center p-5">
                        <i class="pi pi-inbox text-700 text-5xl mb-3"></i>
                        <span class="text-700">No orders found</span>
                    </div>
                </td>
            </tr>
        </ng-template>


        <ng-template pTemplate="rowexpansion" let-order>
            <tr [id]="'order-' + order.order_id">
                <td colspan="9">
                    <div class="p-4 surface-50 border-round shadow-2">
                        <div class="flex flex-wrap align-items-start justify-content-between gap-4">

                            <!-- Assigned Drivers Section -->
                            <div class="flex-1 min-w-15rem">
                                <h5 class="text-primary font-bold mb-2">Assigned Drivers</h5>
                                <div
                                    *ngIf="order.pickup_driver_name && order.delivery_driver_name && order.pickup_driver_name !== order.delivery_driver_name">
                                    <p class="text-sm text-500 mb-1">
                                        Pickup:
                                        <span class="font-semibold text-dark">
                                            {{order.pickup_driver_name}}
                                        </span>
                                    </p>
                                    <p class="text-sm text-500">
                                        Delivery:
                                        <span class="font-semibold text-dark">
                                            {{order.delivery_driver_name}}
                                        </span>
                                    </p>
                                </div>
                                <div
                                    *ngIf="order.pickup_driver_name && order.delivery_driver_name && order.pickup_driver_name === order.delivery_driver_name">
                                    <p class="text-sm text-500">Driver:
                                        <span class="font-semibold text-dark">
                                            {{order.pickup_driver_name}}
                                        </span>
                                    </p>
                                </div>
                                <div *ngIf="!order.pickup_driver_name && !order.delivery_driver_name">
                                    <p class="text-sm text-warning font-semibold">Order Not Yet Assigned</p>
                                </div>
                            </div>

                            <!-- Schedule Section -->
                            <div class="flex-1 min-w-15rem">
                                <h5 class="text-primary font-bold mb-2">Schedule</h5>
                                <p class="text-sm text-500 mb-1">
                                    Pickup:
                                    <span class="font-semibold">
                                        <ng-container *ngIf="order.pickup_date; else noPickupSchedule">
                                            {{toCentralTime(order.pickup_date)}}
                                        </ng-container>
                                        <ng-template #noPickupSchedule>
                                            <span class="text-500">Not Yet Scheduled</span>
                                        </ng-template>
                                    </span>
                                </p>
                                <p class="text-sm text-500">
                                    Delivery:
                                    <span class="font-semibold">
                                        <ng-container *ngIf="order.delivery_date; else noDeliverySchedule">
                                            {{toCentralTime(order.delivery_date)}}
                                        </ng-container>
                                        <ng-template #noDeliverySchedule>
                                            <span class="text-500">Not Yet Scheduled</span>
                                        </ng-template>
                                    </span>
                                </p>
                            </div>

                            <!-- Status Times Section -->
                            <div class="flex-1 min-w-15rem">
                                <h5 class="text-primary font-bold mb-2">Status Times</h5>
                                <div *ngIf="!order.time_loaded && !order.time_unloaded && !order.time_delivered">
                                    <p class="text-sm text-warning font-semibold">No Current Load Updates</p>
                                </div>
                                <p *ngIf="order.time_loaded" class="text-sm text-500 mb-1">
                                    Loaded: <span class="font-semibold">{{toCentralTime(order.time_loaded)}}</span>
                                </p>
                                <p *ngIf="order.time_delivered" class="text-sm text-500">
                                    Delivered: <span
                                        class="font-semibold">{{toCentralTime(order.time_delivered)}}</span>
                                </p>
                            </div>

                            <div class="flex gap-1 justify-content-center w-15rem">
                                <div *ngIf="order.html" class="flex-1 min-w-14rem">
                                    <h5 class="text-primary font-bold mb-2 text-center">View Tender</h5>
                                    <div class="flex justify-content-center">
                                        <p-button icon="pi pi-file" rounded="true" outlined="true" severity="info" (click)="viewTender(order.html, 'tender')"></p-button>
                                    </div>
                                </div>

                                <div *ngIf="order.cancel_html" class="flex-1 min-w-20rem">
                                    <h5 class="nowrap text-primary font-bold mb-2 text-center">Cancelled Tender</h5>
                                    <div class="flex justify-content-center">
                                        <p-button icon="pi pi-file" rounded="true" outlined="true" severity="danger" (click)="viewTender(order.cancel_html, 'cancel')"></p-button>
                                    </div>
                                </div>
                            </div>

                            <!-- Actions Section -->
                            <div class="flex-1 min-w-10rem text-center">
                                <h5 class="text-primary font-bold mb-2"></h5>
                                <p-button *ngIf="hasAccess" icon="pi pi-pencil" label="Edit Order" rounded="true"
                                    outlined="true" raised="true" (onClick)="editOrderDialog.editOrder(order.order_id)">
                                </p-button>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>


<p-toast></p-toast>

<app-new-order-dialog [customers]="customers" [receiverOptions]="receiverOptions" [supplierOptions]="supplierOptions"
    [trailers]="trailers" [loadTypesArray]="loadTypesArray" [loadType]="loadType"
    #newOrderDialog></app-new-order-dialog>

<app-edit-order-dialog [allOrders]="allOrders" [customers]="customers" [trailers]="trailers"
    [loadTypesArray]="loadTypesArray" [loadType]="loadType" #editOrderDialog></app-edit-order-dialog>

<app-tender-dialog #tenderDialog [customers]="customers" [receiverOptions]="receiverOptions"
    [supplierOptions]="supplierOptions" [trailers]="trailers" [loadTypesArray]="loadTypesArray" [loadType]="loadType"
    [allOrders]="allOrders">
</app-tender-dialog>

<p-dialog [(visible)]="viewTenderVisible" [style]="{ width: '47vw', maxWidth: '800px', height: '100vh' }" position="right" [modal]="false"
    [blockScroll]="true" [closable]="true" styleClass="tender-dialog">
    <ng-template pTemplate="header">
        <span class="text-lg font-bold">{{dialogTitle}}</span>
    </ng-template>
    <div class="email-content">
        <iframe *ngIf="selectedHtml" [srcdoc]="selectedHtml" frameborder="0"></iframe>
        <div *ngIf="!selectedHtml" class="error-message">
            <p>No content available</p>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton label="Close" icon="pi pi-times" class="p-button-text" (click)="viewTenderVisible = false"></button>
    </ng-template>
</p-dialog>